import React, { forwardRef } from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import TournamentForm from '../components/TournamentForm';

/**
 * DetailsTab - Tournament details and edit form
 *
 * @param {Object} props
 * @param {Object} props.tournament - Tournament data
 * @param {boolean} props.isOrganizer - Whether current user is organizer
 * @param {boolean} props.isEditing - Whether in edit mode
 * @param {boolean} props.loading - Loading state
 * @param {Function} props.onEdit - Edit button callback
 * @param {Function} props.onDelete - Delete button callback
 * @param {Function} props.onSave - Save changes callback
 * @param {Function} props.onCancel - Cancel edit callback
 */
const DetailsTab = forwardRef(({
  tournament,
  isOrganizer,
  isEditing,
  loading,
  onEdit,
  onDelete,
  onSave,
  onCancel,
  onImageUploaded,
  onImageSelected
}, ref) => {
  const { theme } = useTheme();

  const disabled = !isOrganizer || !isEditing;


  return (
    <div>
      <TournamentForm
        ref={ref}
        initialData={tournament}
        onSubmit={onSave}
        onCancel={onCancel}
        isEditing={isEditing}
        disabled={disabled}
        submitLabel="Save Changes"
        loading={loading}
        onImageUploaded={onImageUploaded}
        onImageSelected={onImageSelected}
      />
    </div>
  );
});

DetailsTab.displayName = 'DetailsTab';

export default DetailsTab;
